import { processHtmlAttributes } from "../../common/html-attributes/index.js";
static function noop() {}
$ const {
  class: inputClass,
  style,
  size,
  ...htmlInput
} = input;
$ input.toJSON = noop;
<span class=["radio", inputClass] style=style>
  <input ...processHtmlAttributes(htmlInput) type="radio" class="radio__control" onClick("forwardEvent", "change") onFocus("forwardEvent", "focus") onKeydown("forwardEvent", "keydown")>
  <span class="radio__icon" hidden>
    <if(size === "large")>
      <ebay-radio-unchecked-24-icon class="radio__unchecked" focusable="false" no-skin-classes/>
      <ebay-radio-checked-24-icon class="radio__checked" focusable="false" no-skin-classes/>
    </if>
    <else>
      <ebay-radio-unchecked-18-icon class="radio__unchecked" focusable="false" no-skin-classes/>
      <ebay-radio-checked-18-icon class="radio__checked" focusable="false" no-skin-classes/>
    </else>
  </span>
</span>